export const environment = {
  /** 本番環境 */
  production: true,

  /** エラーをサーバーに送信する */
  sendError: true,

  /** 認証を有効にする */
  auth: true,

  /** サービスライセンス制御を有効にする */
  serviceLicense: true,

  /** データライセンス制御を有効にする */
  dataLicense: true,

  /** エラー画面にスタックトレースを表示する */
  stackTrace: true,

  /** OEMクラウドストレージバケット */
  oemCloudStorageBuckets: 'https://storage.googleapis.com/test01-blcloud-oem-storage',

  /** Googleドライブ連携用変数 */
  googleDriveAPI: {
    clientId: '646946585062-njbpgenm19f1ke152cecj7kem5nkdkec.apps.googleusercontent.com'
  },

  /** 受発注PF規約 */
  partsOrderAgreement: {
    path: 'https://sfc.blcloud.jp/support/public/clause',
    fileName: 'PF_TermofUse.pdf',
  },

  /** リサイクル規約 */
  recycleAgreement: {
    path: 'https://test-01.blcloud.jp/support/public/clause',
    fileName: 'RC_TermofUse.pdf',
  },

  /** yahooボタン コールバックURL */
  yahooButtonCallbackURL: 'https://test-01.blcloud.jp/maintenance/company/onlinecompany/externalservices',

  /** Yahoo公開鍵の設定動画URL */
  // tslint:disable-next-line: max-line-length
  yahooPublicKeySettingMovieURL: 'https://blnavi.broadleaf.co.jp/movie/detail/166/?utm_source=recyclesystem&utm_medium=system&utm_campaign=yahoosecretkey20230719&utm_term=yahoosecretkey20230719&utm_content=yahoosecretkey',

  /** OpenAM */
  openAM: {
    origin: 'https://test-01-loginbp.blcloud.jp',
    receiver: '/bitool/receiver.html'
  },

  /** 収録データ外部リンクURL */
  recordingGuideBaseUrl: 'https://test-01.blcloud.jp/recording_guide',

  /** くるまコンシェルジュ紹介URL */
  carConciergeIntroductionUrl: '',

  /** 物流PFの配送管理URL */
  deliveryPfManageUrl: 'https://test-blcloud-logi-admin.web.app/',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts